var app = angular.module("leonardo");

var OnBoardingStates = function($stateProvider) {
  $stateProvider.state('onboarding', {
    url: "/onboarding",
    parent: 'authenticated.layout-no-cols',
    onboarding: true,
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      },
      'content': {
        templateUrl: 'views/templates/onboarding/base.html'
      },
      'content@onboarding': {
        templateUrl: 'views/templates/template/list.html',
        controller: 'TemplateList'
      },
      'actions@onboarding': {
        templateUrl: 'views/templates/actions/template-onboarding-list.html'
      }
    }
  });
  $stateProvider.state('onboarding.template-edit', {
    url: "/template/:pk/edit",
    params: {
      pk: '',
      squash: false
    },
    onboarding: true,
    views: {
      'filter@onboarding': {},
      'actions@onboarding': {},
      'content@onboarding': {
        controller: 'TemplateForm',
        templateUrl: 'views/templates/template/form.html'
      }
    },
    resolve: {
      templateObj: ['TemplateService', '$stateParams', function(TemplateService, $stateParams) {
        return TemplateService.get($stateParams.pk);
      }]
    }
  });

  $stateProvider.state('onboarding.user-create', {
    url: "/user-create",
    onboarding: true,
    action: 'create',
    views: {
      'content@authenticated.layout-no-cols': {
        controller: 'OnBoardingAccountUserAdd',
        templateUrl: 'views/templates/onboarding/account-user-add.html'
      }
    }
  });
};

app.config(['$stateProvider', OnBoardingStates]);
